import { TaxTypes } from '../../../../common/enum/TaxTypes';

export const taxTypeTranslationMap: { [value in TaxTypes]: string } = {
  [TaxTypes.VAT]: '',
  [TaxTypes.GST]: '',
  [TaxTypes.GVT]: 'trans__configurator__customise_page_summary_section__selection_accessory_goverment_charges',
  [TaxTypes.HANDLING_FEE]: '',
  [TaxTypes.NOVA_TOTAL]: '',
  [TaxTypes.LICENSE_FEE]: 'trans__configurator__customise_page_summary_expanded__license_fee',
  [TaxTypes.LICENSE_PLATE]: 'trans__configurator__customise_page_summary_expanded__license_plate',
  [TaxTypes.REGISTRATION_FEE]: 'trans__configurator__customise_page_summary_section__fees_and_charges_registration_fee',
  [TaxTypes.TAVAF]: 'trans__configurator__customise_page_summary_expanded__tavaf',
  [TaxTypes.FRT]: 'trans__configurator__customise_page_summary_section__first_registration_tax_label',
  [TaxTypes.LESS_FRT]: 'trans__configurator__customise_page_summary_section__less_tax',
  [TaxTypes._AGGREGATE_FEE]: 'trans__configurator__customise_page_summary_section__fees',
  [TaxTypes.DELIVERY_FEE]: 'trans__configurator__customise_page_summary_section__delivery_charge',
  [TaxTypes.DEALER_DELIVERY_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_dealer_delivery_fee',
  [TaxTypes.DEALER_DELIVERY_CHARGE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_dealer_delivery_fee',
  [TaxTypes.LUXURY_CAR_TAX]: 'trans__configurator__customise_page_summary_section__fees_and_charges_luxury_car_tax',
  [TaxTypes.STAMP_DUTY]: 'trans__configurator__customise_page_summary_section__fees_and_charges_stamp_duty',
  [TaxTypes.VEHICLE_TAX]: 'trans__configurator__customise_page_summary_section__fees_and_charges_vehicle_tax',
  [TaxTypes.HYBRID_DISCOUNT]: 'trans__configurator__customise_page_summary_section__fees_and_charges_hybrid_discount',
  [TaxTypes.RECORDING_FEE]: 'trans__configurator__customise_page_summary_section__fees_and_charges_recording_fee',
  [TaxTypes.ADMINISTRATION_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_administration_fee',
  [TaxTypes.REGISTRATION_PLATES]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_registration_plates',
  [TaxTypes.GENERAL_ISSUE_NAMEPLATE_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_general_issue_nameplate_fee',
  [TaxTypes.TAC_AMOUNT]: 'trans__configurator__customise_page_summary_section__fees_and_charges_tac_amount',
  [TaxTypes.ELECTRIC_VEHICLE_CONCESSION]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_electric_vehicle_concession',
  [TaxTypes.TRAFFIC_IMPROVEMENT_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_traffic_improvement_fee',
  [TaxTypes.CTP_AMOUNT]: 'trans__configurator__customise_page_summary_section__fees_and_charges_ctp_amount',
  [TaxTypes.TIO_AMOUNT]: 'trans__configurator__customise_page_summary_section__fees_and_charges_tio_amount',
  [TaxTypes.PRESCRIBED_FLAT_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_prescribed_flat_fee',
  [TaxTypes.LIFETIME_SUPPORT_FUND]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_lifetime_support_fund',
  [TaxTypes.EMERGENCY_SERVICES_LEVY]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_emergency_services_levy',
  [TaxTypes.ROAD_SAFETY_LEVY]: 'trans__configurator__customise_page_summary_section__fees_and_charges_road_safety_levy',
  [TaxTypes.MOTOR_TAX]: 'trans__configurator__customise_page_summary_section__fees_and_charges_motor_tax',
  [TaxTypes.FIRE_LEVY]: 'trans__configurator__customise_page_summary_section__fees_and_charges_fire_levy',
  [TaxTypes.MAIB_AMOUNT]: 'trans__configurator__customise_page_summary_section__fees_and_charges_maib_amount',
  [TaxTypes.VIC_ROADS_INSPECTION_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_vic_inspection',
  [TaxTypes.VIC_ROADS_ONLINE_ADMIN_FEE]:
    'trans__configurator__customise_page_summary_section__fees_and_charges_vic_online_admin',
  [TaxTypes.CIRCULATION_PERMIT]: 'trans__se__admin_modal_taxation__circulation_permit',
  [TaxTypes.MANDATORY_INSURANCE]: 'trans__se__admin_modal_taxation__mandatory_insurance_tax',
  [TaxTypes.REGISTRATION_TAX]: 'trans__se__admin_modal_taxation__registration_tax',
  [TaxTypes.PROCESSING_COST]: 'trans__se__admin_modal_taxation__processing_cost_fee',
  [TaxTypes.GREEN_TAX]: 'trans__se__admin_modal_taxation__green_tax',
  [TaxTypes.TAG_CHARGE]: 'trans__se__admin_modal_taxation__tag_charge',
  [TaxTypes.TAG_RETURN_CHARGE]: 'trans__se__admin_modal_taxation__tag_return_charge',
  [TaxTypes.FORUM_REGISTRATION_CHARGE]: 'trans__se__admin_modal_taxation__forum_registration_charge',
  [TaxTypes.AUTHORIZED_COURTESY_CHARGE]: 'trans__se__admin_modal_taxation__authorized_courtesy_charge',
};
